module.exports = __webpack_public_path__ + "img/spitiart-logo.54ba7e77.svg";